import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VContainer,[_c(VSheet,[_c(VCardTitle,[_vm._v(_vm._s(_vm.$t("galleryTitle")))]),_c(VContainer,[_c(VRow,{attrs:{"dense":""}},_vm._l((_vm.location.images),function(image,k){return _c(VCol,{key:k,attrs:{"md":2,"sm":4}},[_c(VCard,{attrs:{"tile":""}},[_c(VImg,{attrs:{"src":image.url,"height":"150px"}})],1)],1)}),1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }